import {
  Box,
  FormControl,
  Stack,
  TextField,
  IconButton,
  Button,
  useTheme
} from '@mui/material';
import { styled } from '@mui/material/styles';
import SearchTwoToneIcon from '@mui/icons-material/SearchTwoTone';
import { KeyboardEvent, useMemo, useState } from 'react';
import { useAppSelector } from 'src/app/hooks';
import ClearIcon from '@mui/icons-material/Clear';
import useOnlineMedia from 'src/services/useOnlineMedia';
import { fillParamAdvanceSearchEmpty } from 'src/utils/fillParamAdvanceSearchEmpth';
import TooltipCustomize from 'src/components/TooltipCustomize';
import RefreshIcon from '@mui/icons-material/Refresh';
import DateRangeLabel from 'src/layouts/SidebarLayout/components/DateRangeLabel';
import SelectDateRangeRetail from 'src/components/Retail/SelectDateRangeRetail';

const CustomBox = styled(Box)(
  ({ theme }) => `
    // width: calc(100vw - ${theme.sidebar.width} - ${theme.spacing(10)});
    margin: ${theme.spacing(2, 0)};
    // position: absolute;
`
);

const FilterBox = styled(Box)(
  ({ theme }) => `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`
);

function BottomHeader() {
  const theme = useTheme();
  const [localSearch, setLocalSearch] = useState<string>('');
  const advanceSearchOnlineMedia = useAppSelector(
    (state) => state.storeAdvanceSearchOnlineMedia
  );
  const projectId = useAppSelector((state) => state.users.project.id);
  const { dateRangeFormatted } = useAppSelector(
    (state) => state.analyticArguments
  );

  const statisticGranularity = useAppSelector(
    (state) => state.storeOnlineMediaStream.statisticGranularity
  );

  const fillAdvanceSearchOnlineMedia = useMemo(() => {
    return fillParamAdvanceSearchEmpty(advanceSearchOnlineMedia);
  }, [advanceSearchOnlineMedia]);

  const { getAllMetricStatistic } = useOnlineMedia();
  const timezone = useAppSelector((state) => state.users.project.timezone);

  const finalPayload = {
    ...fillAdvanceSearchOnlineMedia,
    projectId,
    ...dateRangeFormatted,
    granularity: statisticGranularity,
    timezone,
    page: 1,
    limit: 20
  };

  const handleSearch = () => {
    getAllMetricStatistic({ ...finalPayload, phrases: [localSearch] });
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') handleSearch();
  };

  const handleClear = () => {
    setLocalSearch('');
    getAllMetricStatistic({ ...finalPayload, phrases: [] });
  };

  const handleRefresh = () => {
    getAllMetricStatistic(finalPayload);
  };

  return (
    <CustomBox>
      <FilterBox flexWrap={'wrap'} gap={2}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <TextField
            size="small"
            sx={{ width: { xs: '100%', md: 400 } }}
            InputProps={{
              startAdornment: (
                <IconButton size="small" onClick={handleSearch}>
                  <SearchTwoToneIcon htmlColor="#757575" />
                </IconButton>
              ),
              sx: { borderRadius: '16px', backgroundColor: 'white' },
              endAdornment: localSearch ? (
                <IconButton size="small" onClick={handleClear}>
                  <ClearIcon />
                </IconButton>
              ) : null
            }}
            placeholder="Search media"
            onChange={(e) => setLocalSearch(e.target.value)}
            value={localSearch}
            onKeyDown={handleKeyDown}
          />
          <FormControl size="small" sx={{ width: 135 }}>
            <SelectDateRangeRetail
              selectProps={{
                sx: {
                  borderRadius: '16px',
                  width: '135px'
                }
              }}
            />
          </FormControl>
        </Stack>
        <Stack direction={'row'} spacing={1}>
          <TooltipCustomize title="Refresh all metric" placement="top-start">
            <Button
              variant="contained"
              onClick={handleRefresh}
              sx={{
                borderRadius: '6px',
                height: theme.spacing(5),
                minWidth: theme.spacing(6),
                background: theme.palette.primary.main
              }}
            >
              <RefreshIcon />
            </Button>
          </TooltipCustomize>
        </Stack>
      </FilterBox>
      <DateRangeLabel label={`Viewing data within`} />
    </CustomBox>
  );
}

export default BottomHeader;
